import { ReactNode } from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";

import EmptyState from "@/components/emptyState/EmptyState";
import Button from "@/components/button/button";
import { canReloadWithoutLogout, reloadPage } from "@/utils/chunkReload";

const ErrorFallback = () => {
  const { t } = useTranslation();
  return (
    <EmptyState
      title={t("emptyState.globalWrong")}
      text={t("emptyState.historyText")}
      action={
        canReloadWithoutLogout() && <Button label={t("emptyState.tryAgain")} onClick={reloadPage} />
      }
    />
  );
};

const WidgetErrorBoundary = ({ children }: { children: ReactNode }) => (
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>{children}</Sentry.ErrorBoundary>
);

export default WidgetErrorBoundary;
